import React from "react";
import PropTypes from "prop-types";

function reasonMarkup(reason) {
  const html = String(reason).replace(
    /https?:\/\/((?:www\.)?dreamchimney\.com)(?![a-z0-9.-])/gi,
    (_, host) => `https://${host.toLowerCase()}`
  );
  return { __html: html };
}

const ProfileArchiveReason = ({ reason }) => (
  <div className="profile-right-nav profile-reason">
    <h3>Reason To Become a Chimney</h3>
    <div className="reason-body" dangerouslySetInnerHTML={reasonMarkup(reason)} />
  </div>
);

ProfileArchiveReason.propTypes = {
  reason: PropTypes.string,
};

export default ProfileArchiveReason;
